<template>
  <div :class="`${element.compData.type}-theme-${element.compData.styleId}`" :style="{...getStyles(element.compData.styles),
       width: element.width + 'px',
       height: element.height + 'px'}">
    <div class="weather">
      <div class="content">
        <div class="base-weather-info">
          <img v-if="Boolean(element.compData.imgSrc)" :src="handleRepairePublicPrefix(element.compData.imgSrc)" />
          <span>{{ element.compData.data["now"].text }}</span>
          <span>{{ element.compData.data["now"].temperature }}℃</span>
        </div>

        <div v-if="element.compData.selectKeys.includes('humidity')">
          <span>湿度:{{ element.compData.data["now"].humidity }}%</span>
        </div>

        <div v-if="element.compData.selectKeys.includes('quality')">
          <span>空气质量:{{ element.compData.data["air"].quality }}</span>
        </div>

        <div v-if="element.compData.selectKeys.includes('wind_direction')">
          <span>风向:{{ element.compData.data["now"].wind_direction }}</span>
        </div>

        <div v-if="element.compData.selectKeys.includes('wind_scale')">
          <span>风力:{{ element.compData.data["now"].wind_scale }}级</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// iview
import { Input } from "view-design";
import { handleRepairePublicPrefix } from '@/util'

export default {
  name: "compWeather",
  props: {
    element: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      handleRepairePublicPrefix
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onmounted',
        eventData: {
          value: null,
          data: this.plugin,
          event: null
        }
      })
    })
  },
  methods: {
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return res
    },
  },
  components: {
    Input,
  },
};
</script>

<style lang="less" scoped>
  .weather {
    width: 100%;
    height: 100%;
  }
  .content {
    color: var(--fontColor);
    font-family: var(--fontFamily) !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .content > div {
    padding: 0 10px;
    font-size: calc(var(--fontSize) - 6px);
  }
  .base-weather-info {
    display: flex;
    align-items: center;
    font-size: var(--fontSize)!important; //天气和温度
    img {
      width: calc(var(--fontSize) * 1.2);
      height: var(--fontSize);
      margin-right: 10px;
    }
    span:nth-child(2) {
      padding-right: 20px;
    }
  }
</style>
